import React, { useEffect } from "react";
import { Modal } from "../../modal/Modal";
import { playAudioWithRetry, forceStopAllAudio } from "../../../utils/Utils";
import './ExamineticsInstructionModal.scss';

const ExamineticsInstructionModal = ({
    isShow,
    exercise,
    isVoiceEnabled = true,
    onPerformLater,
    onStartTest
}) => {

    useEffect(() => {
        if (isShow && exercise && Object.keys(exercise).length > 0) {
            const audioUrl = exercise?.ExerciseGuideline?.AudioUrlWeb;
            if (audioUrl && isVoiceEnabled) {
                playAudioWithRetry(audioUrl, { priorityLevel: 2 });
            }
        }

        return () => {
            if (isShow) {
                forceStopAllAudio();
            }
        };
    }, [isShow, exercise, isVoiceEnabled]);

    if (!exercise || Object.keys(exercise).length === 0) return null;

    const title = exercise?.ExerciseDisplayName || "Exercise";
    const instruction = exercise?.ExerciseGuideline?.InstructionPatient || "";
    const mediaUrl = exercise?.ExerciseGuideline?.MediaUrl || null;
    const isVideo = mediaUrl && mediaUrl.toLowerCase().endsWith('.mp4');

    return (
        <Modal isOpen={isShow} className="modal-lg examinetics-instruction-modal" centered>
            <div className="modal-content-container">
                <div className="custom-modal-header">
                    <div className="instruction-header-box">
                        <h4 className="instruction-header-title">
                            {title} – Instruction
                        </h4>
                    </div>
                </div>

                <div className="custom-modal-body">
                    {instruction && (
                        <div className="instruction-body-text">
                            {instruction}
                        </div>
                    )}

                    <div className="media-carousel-root">
                        {/* <div className="carousel-arrow left">
                            <i className="fa-solid fa-chevron-left"></i>
                        </div> */}

                        {mediaUrl && (
                            <div className="instruction-media-container">
                                {isVideo ? (
                                    <video autoPlay loop muted playsInline>
                                        <source src={mediaUrl} type="video/mp4" />
                                    </video>
                                ) : (
                                    <img src={mediaUrl} alt={title} />
                                )}
                            </div>
                        )}

                        {/* <div className="carousel-arrow right">
                            <i className="fa-solid fa-chevron-right"></i>
                        </div> */}
                    </div>

                    {/* <div className="carousel-dots">
                        <span className="dot active"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                    </div> */}
                </div>

                <div className="custom-modal-footer">
                    <button
                        type="button"
                        className="btn-perform-later"
                        onClick={onPerformLater}
                    >
                        Perform Later
                    </button>
                    <button
                        type="button"
                        className="btn-start-test"
                        onClick={onStartTest}
                    >
                        Start Test
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ExamineticsInstructionModal;
